import React from 'react';
import OpportunityEmblem from './OpportunityEmblem';

// Presentational card face. Board.jsx wraps it in the draggable/clickable shell.
// `product` ('mortgage' | 'real_estate') puts the OpportunityEmblem on the
// card so every board tells the two kinds apart the same way.
export default function BoardCard({ product, avatar, title, subtitle, footerLeft, footerRight, badge }) {
  return (
    <>
      <div className="flex items-center gap-2 mb-2">
        <div className="w-7 h-7 rounded-full flex items-center justify-center font-semibold text-[10px] flex-shrink-0"
          style={{ background: '#070B5F', color: '#A6E56C' }}>{avatar}</div>
        <div className="font-semibold text-sm flex-1 truncate" style={{ color: '#070B5F' }}>{title}</div>
        {badge}
        <OpportunityEmblem product={product} size={12} />
      </div>
      <div className="text-xs text-slate-500 truncate">{subtitle || '—'}</div>
      {(footerLeft || footerRight) && (
        <div className="flex items-center justify-between mt-2 pt-2 border-t border-slate-100">
          <span className="text-xs text-slate-600">{footerLeft}</span>
          <span className="text-xs font-bold" style={{ color: '#6BA82E' }}>{footerRight}</span>
        </div>
      )}
    </>
  );
}
